import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-801c3c4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cinema-detail__episodes-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "cinema__collection-pagination"
}
const _hoisted_3 = { class: "pagination-page" }
const _hoisted_4 = ["title", "onClick"]
const _hoisted_5 = { class: "episode-title" }
const _hoisted_6 = { class: "episode-year" }

import { PropType, computed, ref } from 'vue'
import CinemaImg from '@shared/components/CinemaImg.vue'
import { useScrollCollection } from '@shared/composable/cinema'
import { IconPageLeft } from '@xunlei/thunder-icon-vue'
import { reduceFilename } from '@remote/utils'


export default /*#__PURE__*/_defineComponent({
  props: {
  nfos: {
    type: Array as PropType<API_NFO.NFO[]>,
    required: true,
  },
},
  emits: ['view'],
  setup(__props) {

const props = __props




const dramas = computed(() => props.nfos?.map(item => ({
  ...item.scrape_result, 
  file_id: item.video_info.file_id,
})))

const episodeListNodeRef = ref<HTMLDivElement | null>(null)

const episodeListInnerNodeRef = ref<HTMLDivElement | null>(null)

const {
  isScrollLeftShow,
  isScrollRightShow,
  scrollLeft,
  scrollRight,
  pageIndex,
  pageTotal,
} = useScrollCollection(episodeListNodeRef, episodeListInnerNodeRef)


const calculateProgress = (drama: API_NFO.Drama) => {
  if (drama.last_record && drama.last_record?.during && drama.last_record.viewed_point) {
    const result = Math.floor((drama.last_record.viewed_point / drama.last_record.during) * 100)
    if (Number.isNaN(result)) return 0
    return result
  }
  return 0
}

const getEpisodeName = (drama: API_NFO.Drama) => {
  let name: string | undefined
  if (drama?.short_name) {
    // 如果有short_name，优先使用short_name
    name = drama?.short_name
  } else if (drama?.class !== 'other') {
    // 如果分类不是其他（刮削有结果），使用刮削出来的中文名
    name = drama?.trans_name
  } else {
    // 如果分类是其他（刮削没有结果），使用文件本身的名字
    name = drama.name
  }
  name = reduceFilename(name ?? '') 
  return drama.season === '0' ? name : `${name}·第${drama.season}季`
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isScrollLeftShow) || _unref(isScrollRightShow))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("span", {
            class: _normalizeClass(["pagination-left", { disabled: !_unref(isScrollLeftShow) }]),
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(scrollLeft) && _unref(scrollLeft)(...args)))
          }, [
            _createVNode(_unref(IconPageLeft))
          ], 2),
          _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(pageIndex)) + "/" + _toDisplayString(_unref(pageTotal)), 1),
          _createElementVNode("span", {
            class: _normalizeClass(["pagination-right", { disabled: !_unref(isScrollRightShow) }]),
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(scrollRight) && _unref(scrollRight)(...args)))
          }, [
            _createVNode(_unref(IconPageLeft))
          ], 2)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      ref_key: "episodeListNodeRef",
      ref: episodeListNodeRef,
      class: "cinema-detail__episodes-list hide-scrollbar"
    }, [
      _createElementVNode("div", {
        ref_key: "episodeListInnerNodeRef",
        ref: episodeListInnerNodeRef,
        class: "cinema-detail__episodes"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dramas), (drama) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "episode",
            key: drama.file_id,
            title: `播放 ${getEpisodeName(drama)}`,
            onClick: ($event: any) => (_ctx.$emit('view', drama.file_id))
          }, [
            _createVNode(CinemaImg, {
              class: "vertical",
              img: drama.poster_vertical || drama.poster_horizontal,
              "is-poster-show": true,
              progress: calculateProgress(drama)
            }, null, 8, ["img", "progress"]),
            _createElementVNode("span", _hoisted_5, _toDisplayString(getEpisodeName(drama)), 1),
            _createElementVNode("span", _hoisted_6, _toDisplayString(drama.year) + "年", 1)
          ], 8, _hoisted_4))
        }), 128))
      ], 512)
    ], 512)
  ]))
}
}

})